/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 

export enum PaintColour {

      Beige = 0,
      Blue = 1,
      Brown = 2,
      Bronze = 3,
      Yellow = 4,
      Gold = 5,
      Gray = 6,
      Green = 7,
      Orange = 8,
      Red = 9,
      Black = 10,
      Silver = 11,
      Violet = 12,
      White = 13,
      Colourful = 14,
      Pink = 15,

};
